import {  RouteRecordRaw } from 'vue-router'
import Index from "../views/index/index.vue"
import Login from '../views/login/login.vue'
import Dashboard from '../views/dashboard/dashboard.vue'
import ResetPassword from '../views/reset-password/reset-password.vue'
import ForgetPassword from '../views/forget-password/forget-password.vue'

import CustomerPurchaseHistoryList from '@/views/customer/customer-purchase-history-list/customer-purchase-history-list.vue'
import CustomerPurchaseHistoryDetail from '@/views/customer/customer-purchase-history-detail/customer-purchase-history-detail.vue'
import CustomerQuotationList from '@/views/customer/customer-quotation-list/customer-quotation-list.vue'
import CustomerProfile from '@/views/customer/customer-profile/customer-profile.vue'

export const routes: Array<RouteRecordRaw>  = [
    { path: '/login', name: 'Login',  component:  Login },
    { path: '/reset-password', name: 'ResetPassword',  component:  ResetPassword },
    { path: '/forget-password', name: 'ForgetPassword',  component:  ForgetPassword },
    { path: '/',  name: 'Index', component: Index, meta: { requiresAuth: true }, children:[

        { path: '/dashboard', name: 'Dashboard',  component:  Dashboard },
        { path: '/customer/purchase-history/list', name: 'CustomerPurchaseHistory',  component:  CustomerPurchaseHistoryList },
        { path: '/customer/purchase-history/:orderId/detail', name: 'CustomerPurchaseHistoryDetail',  component:  CustomerPurchaseHistoryDetail, props: true },
        { path: '/customer/quotation/list', name: 'CustomerQuotation',  component:  CustomerQuotationList },
        { path: '/customer/profile', name: 'CustomerProfile',  component:  CustomerProfile },

    ]},
]
